import React from "react";
import { AlertCircle, CheckCircle2, FileStack, Languages, Plus, RefreshCw, Sparkles } from "lucide-react";
import HelpTip from "src/stage/HelpTip";
import { useNavigate } from "react-router-dom";
import { Kpi, PageHeader } from "src/stage/StageUi";

// AUTO-WA-39: the shared Stage page header and KPI bar.
const TemplateHeader = ({ onSync, syncing = false, overview = {}, onExamples }) => {
  const navigate = useNavigate();
  const value = (key) => Number(overview[key] || 0).toLocaleString("en-IN");

  return (
    <>
      <PageHeader
        eyebrow="Reach"
        title="Templates"
        description={<>Messages Meta has approved, ready for broadcasts and for starting chats outside the 24-hour window. <HelpTip term="template" /></>}
        actions={(
          <>
            <button type="button" className="ws-btn ws-btn--quiet" onClick={onSync} disabled={syncing}>
              <RefreshCw size={15} className={syncing ? "ws-spin" : ""} />
              {syncing ? "Syncing…" : "Sync with Meta"}
            </button>
            {onExamples && <button type="button" className="ws-btn ws-btn--quiet" onClick={onExamples}><Sparkles size={15} />Examples</button>}
            <button type="button" className="ws-btn ws-btn--primary" onClick={() => navigate("/templates/create")}>
              <Plus size={16} />Create template
            </button>
          </>
        )}
      />
      <section className="ws-card ws-kpis" aria-label="Template overview">
        <Kpi icon={FileStack} label="Templates" value={value("total")} />
        <Kpi icon={CheckCircle2} label="Approved" value={value("approved")} />
        <Kpi icon={AlertCircle} label="Needs attention" value={value("attention")} />
        <Kpi icon={Languages} label="Languages" value={value("languages")} />
      </section>
    </>
  );
};

export default TemplateHeader;
